import React from 'react';
import { Row } from 'react-bootstrap';
import { FormControl } from '../../../form/FormControls.jsx';
import Quantity from '../elements/Quantity.jsx';
import { connect } from 'react-redux';
import { handleFormChanged } from '@/store/allaround.store.js';

const EditForm = (props) => {
  const data = props.defaultValue ? props.defaultValue : undefined;
  return (<form id="edit_link" onChange={props.handleFormChanged}>
    <Row>
      <Quantity data={props.defaultValue} />
    </Row>
    <FormControl
      id="id" name="id" value={data ? data.get('id') : null} style={{ display: 'none' }}
      onChange={() => ({})}
    />
    <FormControl
      id={`${props.dealFrom}Product`}
      name={`${props.dealFrom}Product`} value={props.homeProduct}
      onChange={() => ({})} style={{ display: 'none' }}
    />
    <FormControl
      id="purchaseId" name="purchaseId" value={data ? data.get('purchaseId') : null}
      style={{ display: 'none' }} onChange={() => ({})}
    />
    <FormControl
      id="saleId" name="saleId" value={data ? data.get('saleId') : null} style={{ display: 'none' }}
      onChange={() => ({})}
    />
  </form>);
};

EditForm.propTypes = {
  dealFrom: React.PropTypes.string,
  dealTo: React.PropTypes.string,
  defaultValue: React.PropTypes.object,
  homeProduct: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string]),
  foreignProduct: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string]),
  handleFormChanged: React.PropTypes.func,
  productType: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string]),
  packing: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string]),
};

export default connect(() => ({}), (dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(EditForm);
